import { Line } from './line';
import { CubicBezier, CubicBezierControlPoints } from './bezier';
import { avoidZero, closeNumbers } from './line';
//import { Point2D, Axis, eqPoint } from '../geometry/geometry';
import { Point2D, eqPoint } from '../geometry/geometry';
//import { Polygon, createSegments, circularNext, getPolygonCCW, getPolygonCW } from '../geometry/polygon';
import { Polygon, getPolygonCCW } from '../geometry/polygon';
//import { PlaneSweeper, unionSet, Line as debugline } from '../geometry/plane-sweep';
import {Line as debugline } from '../geometry/plane-sweep';
import { SetSweeper } from '../webgl/set-sweeper';

/**
 * Collection of static path related functions
 */
export class Path {

	public static inflateLineString(lineString: Point2D[], widthStart: number, widthEnd?: number, drawLine?: (line: debugline, color?: string) => void, drawVertex?: (vertex: Point2D, color?: string) => void): Polygon {
		let growStart = widthStart / 2;
		let growEnd = widthEnd !== undefined ? widthEnd / 2 : growStart;

		const extendedLineEnding = (lineString: Point2D[], growStart: number, growEnd: number, extendStart: boolean) => {
			if (lineString.length > 1) {
				return extendStart ?
					Path.getExtendedPoint(lineString[1], lineString[0], growStart) :
					Path.getExtendedPoint(lineString[lineString.length - 2], lineString[lineString.length - 1], growEnd);
			} else {
				return undefined;
			}
		}
		const inflateToSide = (lineString: Point2D[], growStart: number, growEnd: number) => {
			if (lineString.length > 1) {
				return lineString.map((_point, index, list) => {
					const grow = growStart + ((growEnd - growStart) * index) / (lineString.length - 1);
					if (index === 0) {
						//first point
						return Path.getMovedPoint(list[index], list[index + 1], undefined, grow);
					} else if (index === (list.length - 1)) {
						//last point
						return Path.getMovedPoint(undefined, list[index - 1], list[index], grow);
					} else {
						//intermediate point
						return Path.getMovedPoint(list[index - 1], list[index], list[index + 1], grow);
					}
				});
			} else {
				return lineString;
			}
		};
       const purifiedLineString = Path.purify(lineString);
		if (purifiedLineString.length > 1) {
			
			let vertices = getPolygonCCW(<Point2D[]>[extendedLineEnding(purifiedLineString, growStart, growEnd, true)]
				.concat(inflateToSide(purifiedLineString, growStart, growEnd))
				.concat([extendedLineEnding(purifiedLineString, growStart, growEnd, false)])
				.concat(inflateToSide([].concat(purifiedLineString).reverse(), growEnd, growStart)));

			const clutteredPolygon = new Polygon(vertices, [vertices.map((_v, index) => index)]);
			const setSweeper = new SetSweeper([clutteredPolygon]);
			const polygon = setSweeper.getUnion();
			return polygon;

//			//N.B. last concat call : line reversed and growEnd and growStart swapped
//			//We now have all vertices that make up the polygon in CCW order.
//			//However we need to take care of:
//			//1 - a self intersecting line string
//			//2 - tight bends in the line string (i.e. the bend is tighter then twice the local width)
//			//solution: 
//			// step A: use LineSweep algorithm to find all intersection in the 'raw' polygon
//			// step B: create a map from all sub paths between the intersection points (keyed by there 
//			//         first vertex), starting with the segment with a max value for X or Y. The
//			//         very first path is guaranteed to be an edge of the final polygon. Now walk in
//			//         'raw' vertex order. When we encounter an intersection vertex, we reached the end
//			//         of the current path and trace the next one until we reach the starting vertex.
//			//         Every time we come across an intersection the 'isAnEdgePath' toggles. When the 
//			//         flag is false, we do not create a new path, we simply walk over it until we find,
//			//         the next intersection. So we end up with a map with all sub-paths that lie at the 
//			//         edge of the 'final' polygon. Each path is keyed with their first vertex.  
//			// step C: Now we find all the paths of the 'final' polygon. Again we start with the sub-path
//			//         that has been keyed with the starting vertex (i.e. the vertex with max value for X
//			//         or Y). This starting sub-path is guaranteed to be on the outer contour of the final
//			//         polygon. Now repeat the following loop to find a complete path:
//			//         - find sub-path in map with given key
//			//         - remove sub-path from map
//			//         - append sub-path to path
//			//         - take last vertex of sub-path and make that the new key
//			//         - repeat steps above until no sub-paths can be found in the map and we have 
//			//           constructed our path
//			//         - when the map still contains sub-paths (the holes in the final polygon), take the
//			//           first one and make its first vertex the key and repeat all above
//			// step D: We now got one outerPath and zero or more hole paths that form our 'inflated line'
//			//         polygon. Construct the polygon and return
//
//
//			// STEP A
//			//create segments from the 'raw' polygon vertices and perform sweep line
//			const axis = Axis.Y;//we can pick X as well but most literature use Y
//			const segmentFactoryResult = createSegments(vertices, axis);
//			//we need these in steps B and C
//			const maxSegment = segmentFactoryResult.maxSegment;
//			const maxVertex = vertices[segmentFactoryResult.segments[maxSegment].vertices[0]];
//			//segments holds all segments in 'raw' polygon order with intersection info included
//			//            let segments = LineSweeper.sweep( segmentFactoryResult.segments, vertices, axis );
//			let segments = PlaneSweeper.sweep(unionSet([0]), [new Polygon(vertices, [[...Array(vertices.length).keys()]])], axis, drawLine, drawVertex).segments;
//
//			// STEP B
//			let accu = { edge: true, path: <Point2D[]>undefined, paths: new Map<Point2D, Point2D[]>() };
//			let segment;
//			let isegm = maxSegment;
//			do {
//				segment = segments[isegm];
//				//add vertex0 if we are tracing an edge
//				if (accu.edge) {
//					if (accu.path === undefined) {
//						accu.path = [vertices[segment.vertices[0]]];
//						accu.paths.set(accu.path[0], accu.path);
//					} else {
//						accu.path.push(vertices[segment.vertices[0]])
//					}
//				}
//
//				//handle intersections (if any); each intersection toggles the edge flag
//				if (segment.t) {
//					for (let t of segment.t.inOrder()) {
//						if (accu.edge) {
//							accu.path.push(segment.intersections.get(t));
//							accu.path = undefined;
//							accu.edge = false;
//						} else {
//							accu.path = [segment.intersections.get(t)];
//							accu.paths.set(accu.path[0], accu.path);
//							accu.edge = true;
//						}
//					}
//				}
//
//				isegm = circularNext(isegm, segments);
//			} while (isegm !== maxSegment);
//
//			//add vertex1 of last segment if we are tracing an edge
//			if (accu.edge) {
//				accu.path.push(vertices[segment.vertices[1]])
//			}
//			//the map of sub-paths
//			let pathMap = accu.paths;
//
//			// STEP C
//			let polygonVertices: Point2D[] = [];
//
//			let polygonPath: number[] = [];
//			let path = pathMap.get(maxVertex);
//			let pathStart = maxVertex;
//			let polyVertexIndex = 0;
//
//			let polygonPaths: number[][] = [polygonPath];
//
//			while (pathMap.size > 0) {
//				path = pathMap.get(pathStart);
//				if (path !== undefined) {
//					pathMap.delete(pathStart);
//					//last vertex is the start of the next path and should not be added to the path
//					pathStart = path.pop();
//					path.forEach((vertex, index) => {
//						polygonVertices.push(vertex);
//						polygonPath.push(polygonVertices.length - 1);
//					});
//				} else {
//					pathStart = pathMap.keys().next().value;
//					polygonPath = [];
//					polygonPaths.push(polygonPath);
//				}
//			}
//
//			// STEP D
//			return new Polygon(polygonVertices, polygonPaths);

		} else {
			//no vertices on line string
			return undefined;
		}
	}


	/**
	 * Returns a contour off the same shape as the given contour but inflated/ deflated by the number 
	 * of user-space units given by the gain parameter. A negative gain makes the contour shrink. A 
	 * positive number makes it grow. 
	 * This method should be called for a contour that has been projected to the Cartesian coordinate system. 
	 * @param contour the contour to resize
	 * @param gain the gain in user-space coordinates
	 */
	public static resizeContour(contour: number[][], gain: number): number[][] {
		return Path.resize(Path.preprocessContour(contour, gain), gain);
	}

	private static resize(contour: number[][], gain: number): number[][] {
		let gainedContour: number[][] = [];
		//                let preprocessedContour: number[][];
		let i: number, p0: number[], p: number[], p1: number[], l: number;
		let gp: number[];

		if (contour && contour.length >= 2) {
			l = contour.length;
			for (i = 0; i < l; i++) {
				p0 = contour[i > 0 ? i - 1 : l - 1];
				p = contour[i];
				p1 = contour[i < l - 1 ? i + 1 : 0];

				gp = this.getMovedPoint(p0, p, p1, gain);
				gainedContour.push(gp);
			}
		}
		return gainedContour;
	}
	private static preprocessContour(contour: number[][], gain: number): number[][] {
		let intersects = (segments: Line[], checkSegment: Line) => segments.reduce((intersects, segment) => intersects || (!segment.equals(checkSegment) && segment.intersection(checkSegment, false) !== undefined), false);

		let stdResizedContour = Path.resize(contour, gain);
		let stdSegments = stdResizedContour.map((point, index, path) => new Line(point[0], point[1], path[index < path.length - 1 ? index + 1 : 0][0], path[index < path.length - 1 ? index + 1 : 0][1], 1.0, 'std_' + index));
		let cntrSegments = contour.map((point, index, path) => new Line(point[0], point[1], path[index < path.length - 1 ? index + 1 : 0][0], path[index < path.length - 1 ? index + 1 : 0][1], 1.0, 'cntr' + index));

		return contour
			.map((orgPoint, index, _orgContour) => { return new Line(orgPoint[0], orgPoint[1], stdResizedContour[index][0], stdResizedContour[index][1], 1.0, 'strut_' + index); })
			.filter((strut, _index, _struts) => !intersects(cntrSegments, strut) && !intersects(stdSegments, strut))
			.filter((strut, _index, struts) => !intersects(struts, strut))
			.map(strut => strut.c[0]);
	}

	public static getExtendedPoint(p0: number[], p1: number[], gain: number): number[] {
		const unity = (v: number[]): number[] => {
			const l: number = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
			return [v[0] / l, v[1] / l];
		}
		const v = unity([p1[0] - p0[0], p1[1] - p0[1]]);
		return [
			p1[0] + (v[0] * gain),
			p1[1] + (v[1] * gain)
		];
	}

	/**
	 * Returns the new position of a coordinate based on the local neighbourhood and gain. If p1 is undefined then p0
	 * will be moved. If p0 is undefined then p1 will be moved. When all three are defined then p will be moved. 
	 * @param p0 starting coordinates of the segment that arrives at the centre coordinate of the neighbourhood 
	 * @param p  coordinates of the point where the two segments meet
	 * @param p1 ending coordinates of the segment that leaves from the centre coordinate of the neighbourhood
	 * @param gain the amount of movement in user-space coordinates
	 */
	public static getMovedPoint(p0: number[], p: number[], p1: number[], gain: number): number[] {
		//TODO handle cases where p0,p and p1 lie on one line

		const unity = (v: number[]): number[] => {
			const l: number = Math.sqrt(v[0] * v[0] + v[1] * v[1]);
			return [v[0] / l, v[1] / l];
		}
		const perpendularN = (pa: number[], pb: number[]): number[] => {
			return unity([pa[1] - pb[1], pb[0] - pa[0]]);
		};

		//calculate unity vector perpendicular to line from p0 to p 
		let n0 = p0 ? perpendularN(p0, p) : undefined;
		//calculate unity vector perpendicular to line from p to p1 
		let n1 = p1 ? perpendularN(p, p1) : undefined;

		if (n0 && n1) {
			//the normal case where all three points where defined

			//now express n0 into coordinates of a system where n1 is the positive x-axis
			//let e1 = n1; //just to show what we are doing here
			//let e2 = [-e1[1], e1[0]];
			//let _n0 = [e2[1] * n0[0] - e2[0] * n0[1], e1[0] * n0[1] - e1[1] * n0[0]];

			//now calculate the unity vector of the sum of _n0 and (1,0)
			//let _vc = unity([_n0[0] + 1, _n0[1]]);

			//now calculate the unity vector of the sum of n0 and n1
			let vc = unity([n0[0] + n1[0], n0[1] + n1[1]]);

			//let correction: number = gain / _vc[0];
			//let dP = [vc[0] * correction, vc[1] * correction];
			let dP = [vc[0] * gain, vc[1] * gain];
			return [
				p[0] + dP[0],
				p[1] + dP[1]
			];
		} else if (n0) {
			//p0 and p are defined -> move point0
			return [
				p0[0] + (n0[0] * gain),
				p0[1] + (n0[1] * gain)
			];
		} else {
			//p0 and p are defined -> move point0
			return [
				p1[0] + (n1[0] * gain),
				p1[1] + (n1[1] * gain)
			];

		}
	}

	public static lineStringToSmoothenedLineString(lineString: number[][], flatness: number, smoothing = 0.3333333333): number[][] {
		return Path.lineStringToCurveString(lineString, smoothing, true).reduce((smoothenedLineString: number[][], curve: CubicBezierControlPoints, index: number) => {
			smoothenedLineString.push(...(CubicBezier.linearize(curve, flatness).slice(index === 0 ? 0 : 1)));
			return smoothenedLineString;
		}, <number[][]>[]);
	}

	/**
	 * Returns an array of bezier curves that  make up a smooth curve that runs through all
	 * points on the line string. The optional smoothing parameter indicates how closely we should to resemble the original. The closer to 0 the less
	 * smoothing is applied. The default is 0.3333333.
	 * @param lineString the line string to smoothen and return the path for
	 * @param smoothing a number that indicates how closely we want to resemble the original.
	 */
	public static lineStringToCurveString(lineString: number[][], smoothing = 0.3333333333, removeStraightSections = false): CubicBezierControlPoints[] {
		let curves: CubicBezierControlPoints[] = [];
		//        let path: ( string | number )[][] = [];
		let i: number, p0: number[], p: number[], p1: number[], l: number;
		let cp: number[][];
		let cp1: number[];
		let cp2: number[];
		let cp3: number[];

		smoothing = avoidZero(smoothing);

		if (lineString && lineString.length >= 2) {
			if (lineString.length > 2) {

				lineString = removeStraightSections ? lineString.reduce((cleanedLineString, vertex, index) => {
					if (index == 0) {
						cleanedLineString.push(vertex);
					} else {
						let lastAppendedVertex = cleanedLineString[cleanedLineString.length - 1];
						if (!closeNumbers(lastAppendedVertex[0], vertex[0]) || !closeNumbers(lastAppendedVertex[1], vertex[1])) {
							cleanedLineString.push(vertex);
						}
					}
					return cleanedLineString;
				}, <number[][]>[]) : lineString;

				l = lineString.length;
				//calculate control points for the first and last segments of the line
				let x: number = lineString[1][0] - lineString[0][0];
				let y: number = lineString[1][1] - lineString[0][1];
				let firstCP1: number[] = [lineString[0][0] + smoothing * x,
				lineString[0][1] + smoothing * y
				];

				x = lineString[l - 2][0] - lineString[l - 1][0];
				y = lineString[l - 2][1] - lineString[l - 1][1];
				let lastCP2: number[] = [lineString[l - 1][0] + smoothing * x,
				lineString[l - 1][1] + smoothing * y
				];

				cp1 = firstCP1;

				//          path.push( ["M", lineString[0][0], lineString[0][1]] );

				for (i = 1; i < l - 1; i++) {
					p0 = lineString[i - 1];
					p = lineString[i];
					p1 = lineString[i + 1];

					cp = this.getBezierControlPoints(p0, p, p1, smoothing);

					cp2 = cp[0];
					cp3 = p;

					//            path.push( ["C", cp1[0], cp1[1], cp2[0], cp2[1], cp3[0], cp3[1]] );
					curves.push({
						p0: p0,
						p1: cp1,
						p2: cp2,
						p3: cp3,
						dT: 1.0
					});


					cp1 = cp[1];
				}
				//            path.push( ["C", cp1[0], cp1[1], lastCP2[0], lastCP2[1], lineString[l - 1][0], lineString[l - 1][1]] );
				curves.push({
					p0: cp3,
					p1: cp1,
					p2: lastCP2,
					p3: lineString[l - 1],
					dT: 1.0
				});
			} else {
				//line string consists of 1 segment only so no curvature
				curves.push({
					p0: lineString[0],
					p1: lineString[1],
					p2: lineString[0],
					p3: lineString[1],
					dT: 1.0
				});

			}
		}
		return curves;
	}

	/**
	 * Returns a path definition of the given line string consisting of a series of consecutive Cubic Bezier curves that run through all
	 * points on the line string. The optional smoothing parameter indicates how closely we should to resemble the original. The closer to 0 the less
	 * smoothing is applied. The default is 0.3333333.
	 * This method should be called for a line string that has been projected to the final / Geodetic coordinate system (Mercator). 
	 * @param lineString the line string to smoothen and return the path for
	 * @param smoothing a number that indicates how closely we want to resemble the original.
	 */
	public static smoothenLineString(lineString: number[][], smoothing = 0.3333333333): (string | number)[][] {
		return CubicBezier.toSVGPath(Path.lineStringToCurveString(lineString, smoothing));
	}

	/**
	 * Returns a path definition of the given contour consisting of a series of consecutive Cubic Bezier curves that run through all
	 * points on the contour. The optional smoothing parameter indicates how closely we should to resemble the original. The closer to 0 the less
	 * smoothing is applied. The default is 0.3333333.
	 * This method should be called for a contour that has been projected to the final / Geodetic coordinate system (Mercator). 
	 * @param contour the contour to smoothen and return the path for
	 * @param smoothing a number that indicates how closely we want to resemble the original.
	 * @param hasStartPoint flag indicating that the contour should be drawn like a line string that happens to end at the same location as where it started.
	 */
	public static smoothenContour(contour: number[][], smoothing = 0.3333333333, hasStartPoint = true): (string | number)[][] {
		smoothing = avoidZero(smoothing);
		let path: (string | number)[][];
		if (contour && contour.length >= 2) {
			if (hasStartPoint) {
				path = this.smoothenLineString(contour.concat([
					[contour[0][0], contour[0][1]]
				]), smoothing);
			} else {
				//this code treats all the points on the contour the same way, causing an unwanted artifact at the start point of the hysplit trajectory                     
				path = [];
				let i: number, p0: number[], p: number[], p1: number[], l: number;
				let cp: number[][], lastCP2: number[];
				let cp1: number[];
				let cp2: number[];
				let cp3: number[];

				l = contour.length;
				path.push(["M", contour[0][0], contour[0][1]]);

				for (i = 0; i < l; i++) {

					p0 = contour[i > 0 ? i - 1 : l - 1];
					p = contour[i];
					p1 = contour[i < l - 1 ? i + 1 : 0];

					cp = this.getBezierControlPoints(p0, p, p1, smoothing);

					cp2 = cp[0];
					cp3 = p;

					lastCP2 = lastCP2 ? lastCP2 : cp2;
					if (cp1) {
						path.push(["C", cp1[0], cp1[1], cp2[0], cp2[1], cp3[0], cp3[1]]);
					}
					cp1 = cp[1];
				}
				path.push(["C", cp1[0], cp1[1], lastCP2[0], lastCP2[1], contour[0][0], contour[0][1]]);
			}

			path.push(["Z"]); //auto close path although the last coordinate already is the same as the first
		} else {
			path = []; //too few coordinates so no path
		}
		return path;
	}

	/**
	 * Returns the Cubic Bezier curve control points to use for a coordinate based on the local neighbourhood and 
	 * smoothing.
	 * @param p0 starting coordinates of the segment that arrives at the centre coordinate of the neighbourhood 
	 * @param p  coordinates of the point where the two segments meet
	 * @param p1 ending coordinates of the segment that leaves from the centre coordinate of the neighbourhood
	 * @param smoothing the amount of smoothing to apply. the closer to 0 the less smoothing is applied
	 */
	private static getBezierControlPoints(p0: number[], p: number[], p1: number[], smoothing: number): number[][] {
		let xcp0: number, ycp0: number, xcp1: number, ycp1: number, lcp0: number, lcp1: number, xncp: number, yncp: number, lncp: number, dot: number;

		xcp0 = (p[0] - p0[0]) * smoothing;
		ycp0 = (p[1] - p0[1]) * smoothing;
		lcp0 = Math.sqrt(xcp0 * xcp0 + ycp0 * ycp0);

		xcp1 = (p[0] - p1[0]) * smoothing;
		ycp1 = (p[1] - p1[1]) * smoothing;
		lcp1 = Math.sqrt(xcp1 * xcp1 + ycp1 * ycp1);

		if (!closeNumbers(lcp0, 0) && !closeNumbers(lcp1, 0)) {
			xncp = xcp0 / lcp0 + xcp1 / lcp1;
			yncp = ycp0 / lcp0 + ycp1 / lcp1;
			lncp = Math.sqrt(xncp * xncp + yncp * yncp);

			dot = -yncp * xcp0 + xncp * ycp0;
		} else {
			dot = 0.0;
		}

		if (!closeNumbers(dot, 0)) {
			return [
				[p[0] + (dot < 0 ? -1 : 1) * yncp * lcp0 / lncp,
				p[1] + (dot < 0 ? 1 : -1) * xncp * lcp0 / lncp
				],
				[p[0] + (dot < 0 ? 1 : -1) * yncp * lcp1 / lncp,
				p[1] + (dot < 0 ? -1 : 1) * xncp * lcp1 / lncp
				]
			];
		} else {
			//handle cases where p0,p and p1 lie on one line
			return [[p[0] - xcp0, p[1] - ycp0], [p[0] - xcp1, p[1] - ycp1]];
		}
	}

 public static purify(lineString : Point2D[]): Point2D[] {
	const purifiedLineString = [];
	let i = 0;
	while(i < lineString.length){
		if(i===0){
			purifiedLineString.push(lineString[i]);
		} else {
			if(! eqPoint(purifiedLineString[purifiedLineString.length-1], lineString[i])){
			purifiedLineString.push(lineString[i]);
			}
		}
			i++;
	}
	return purifiedLineString;	
 }

}
